import { useEffect, useContext, useState, createContext } from "react";
import { CREATE_TICKET_MUTATION } from "../api/mutations/ticket.mutations";
import { useMutation } from "@apollo/client";
import { MessagesContext } from "./messages.context";

const defaultTicketForm = {
  make: "",
  model: "",
  asset_serial: "",
  comment: "",
  problem_type: "Other",
  tracking_number: "",
  asset_type: "",
  school: "",
  user_type: "",
  contact_id: "",
};

export const TicketFormContext = createContext({
  ticketForm: {},
  setTicketForm: () => null,
  selectedAsset: "",
  setSelectedAsset: () => null,
  selectedShippingLabel: {},
  setSelectedShippingLabel: () => null,
  createTicket: () => null,
});

export const TicketFormProvider = ({ children }) => {
  const { addMessage } = useContext(MessagesContext);
  const [ticketForm, setTicketForm] = useState(defaultTicketForm);
  const { make, model, asset_serial, problem_type } = ticketForm;
  const [selectedAsset, setSelectedAsset] = useState("");
  const [selectedShippingLabel, setSelectedShippingLabel] = useState({});
  const [createTicketMutation] = useMutation(CREATE_TICKET_MUTATION);

  useEffect(() => {
    setTicketForm({
      ...ticketForm,
      asset_serial: selectedAsset?.asset_serial || "",
      make: selectedAsset?.make || "",
      model: selectedAsset?.model || "",
      tracking_number: selectedShippingLabel?.tracking_number || "",
      asset_type: selectedAsset?.asset_type || "",
    });
  }, [selectedAsset, selectedShippingLabel]);
  const createTicket = async () => {
    // console.log("Starting createTicket process...");
    // console.log("Current ticketForm state:", ticketForm);
    try {
      if (selectedAsset && selectedAsset?.warranty) {
        console.log("Checking warranty for asset:", selectedAsset.id);
        if (new Date(selectedAsset?.warranty_end_date) < new Date()) {
          console.log("Asset is out of warranty.");
          if (!window.confirm("Asset is out of warranty. Continue?")) {
            console.log("User cancelled out-of-warranty submission.");
            return;
          }
        }
      }

      const parsedContactId = parseInt(ticketForm.contact_id);
      const parsedAssetId = parseInt(ticketForm.asset_id);

      // console.log("Parsed IDs - Contact:", parsedContactId, "Asset:", parsedAssetId);

      const variables = {
        ...ticketForm,
        contact_id: isNaN(parsedContactId) ? null : parsedContactId,
        asset_id: isNaN(parsedAssetId) ? null : parsedAssetId,
        subject: `${make} ${model} - ${asset_serial}: ${problem_type}`,
      };

      // console.log("Sending mutation with variables:", variables);

      const { data } = await createTicketMutation({
        variables: variables,
      });

      console.log("Mutation response data:", data);

      if (!data || data.error) {
        console.error("Mutation returned an error or no data:", data?.error);
        throw new Error("Error creating ticket");
      }

      addMessage(`Ticket ${data.createTicket.number} created!`, "success");
      // console.log("Ticket creation successful. Clearing form.");
      setTicketForm(defaultTicketForm);
      setSelectedAsset("");
    } catch (error) {
      // console.error("Caught error in createTicket:", error);
      addMessage(error.message, "error");
    }
  };

  const value = {
    ticketForm,
    setTicketForm,
    selectedAsset,
    setSelectedAsset,
    selectedShippingLabel,
    setSelectedShippingLabel,
    createTicket,
  };
  return (
    <TicketFormContext.Provider value={value}>
      {children}
    </TicketFormContext.Provider>
  );
};
